module.exports = __webpack_public_path__ + "img/strategy_bb_grey.f6c4a49a.svg";